<div class="tire-dot-number">
    <div class="tire-dot-number-header mb-0">
        <div class="ui-g-12 flex-between-center p-0">
            <div class="flex-start-center width-100p">
                <img *ngIf="!data.isAllServiceItems" class="mt-1" style="height: 18px;"
                    src="assets/img/icon/dot-number-black.svg" alt="dot number">
                <div class="ml-2 width-100p p-relative font-600 font-16 mt-1">{{data.dotNumberTitle ? data.dotNumberTitle : currentLang === 'fr' ? 'Pneu DOT#' : 'Tire DOT#'}}
                </div>
            </div>
            <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog('close')"></i>
        </div>
    </div>
    <!-- body -->
    <div class="flex-start-center">
        <div *ngIf="isUnassignedAvailable && isSalesCodeEnabled"
          class="flex-center-center sales-code-assign pointer font-14 font-600"
          (click)="openAssignAllSalesCodeModal()">
          <i class="far fa-plus"></i>
          {{currentLang === 'fr' ? 'Attribuer tous les codes de vente' : 'Assign All Sales Codes'}}
        </div>
      </div>
    <app-authorization-sales-code-assignment *ngIf="isUnassignedAvailable && isSalesCodeEnabled" [services]="unassignedServices.unassignedServiceItems"
    [assignedSalesCodeItems]="[]"
    [isFinalizedRo]="true"></app-authorization-sales-code-assignment>
    <div *ngIf="!data.isTech && !data.isAllServiceItems && !isMultipleTires" class="body-tire-dot-number">
        <tire-add-dot-number [data]="data" (onInputChange)="handleChange($event.value, $event.item)"
            (onSwitchBtnChange)="onCardTypeSelect($event.data, $event.item)">
        </tire-add-dot-number>
    </div>

    <div *ngIf="!data.isTech && !data.isAllServiceItems && isMultipleTires" class="body-tire-dot-number">
        <ng-container *ngFor="let tire of tires">
            <div class="font-600 ml-15">{{currentLang === 'fr' ? 'Pneu' : 'Tire'}} #{{tire.title}}</div>
            <tire-add-dot-number [data]="tire" (onInputChange)="handleChange($event.value, $event.item)"
                (onSwitchBtnChange)="onCardTypeSelect($event.data, $event.item)">
            </tire-add-dot-number>
        </ng-container>
    </div>

    <div class="tire-dot-number-body border-bottom" *ngIf="data.isTech">
        <ng-container *ngFor="let dot of data.dotNumbers; let i=index;">
            <div class="font-600">{{currentLang === 'fr' ? 'Pneu' : 'Tire'}} #{{i+1}}</div>
            <div class="d-flex my-2 px-0">
                <div class="p-0 w-dot-num">
                    <app-input type="text" [maxLength]="30" theme="border" class="font-13"
                        [id]="'dot-number-'+i" [hasHoverBorderBottom]="false" [placeholder]="currentLang === 'fr' ? 'Entrez le numéro DOT' : 'Enter DOT#'"
                        [disabled]="false" [dropSpecialCharacters]="true" [hasHoverEffect]="false"
                        (appChange)="handleChange($event, dot)" [value]="dot.dotNumber">
                    </app-input>
                </div>
                <div class="p-0 pl-2 w-tire-position" [pTooltip]="dot.tooltip || ''" tooltipPosition="top"
                    tooltipStyleClass="tire-dot-tooltip">
                    <app-dropdown [placeholder]="data.positionPlaceholder" theme="border" [field]="currentLang === 'fr' ? 'labelFR' : 'label'"
                        [id]="'tire-position-'+i" [fontSize]="14" [disabled]="!dot.dotNumber" [listItemFontSize]="14"
                        [options]="tirePositions" [value]="dot.tirePosition" (appSelect)="onCardTypeSelect($event, dot)"
                        [isDropdownIconVisible]="true">
                    </app-dropdown>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="tire-dot-number-body border-bottom" *ngIf="data.isAllServiceItems">
        <ng-container *ngFor="let tire of data.tires;">
            <!-- <div [attr.data-toggle]="highLightedTireId === tire.id ? 'expand': 'collapse'"
                [attr.data-target]="'#tire'+tire.id" [attr.aria-expanded]="highLightedTireId === tire.id"
                [attr.aria-controls]="'tire'+tire.id"> -->
            <div class="font-600 pb-2">{{tire.title}}</div>
            <!-- </div> -->

            <ng-container *ngFor="let dot of tire.dotNumbers; let i=index;">
                <!-- <div [attr.aria-labelledby]="tire.id"  class="{{highLightedTireId === tire.id? 'expand': 'collapse'}}"> -->
                <div class="font-300">{{currentLang === 'fr' ? 'Pneu' : 'Tire'}} #{{i+1}}</div>
                <div class="d-flex my-2 px-0">
                    <div class="p-0 w-dot-num">
                        <app-input type="text" [maxLength]="30" theme="border" class="font-13"
                            [id]="'dot-number-'+i" [hasHoverBorderBottom]="false" [placeholder]="currentLang === 'fr' ? 'Entrez le numéro DOT' : 'Enter DOT#'"
                            [disabled]="false" [errorMessage]="" [isInvalid]="dot.isInvalid"
                            [dropSpecialCharacters]="true" [hasHoverEffect]="false"
                            (appChange)="handleChange($event, dot)" [value]="dot.dotNumber">
                        </app-input>
                    </div>
                    <div class="p-0 pl-2 w-tire-position" [pTooltip]="dot.tooltip || ''" tooltipPosition="top"
                        tooltipStyleClass="tire-dot-tooltip">
                        <app-dropdown [placeholder]="data.positionPlaceholder" theme="border" [field]="currentLang === 'fr' ? 'labelFR' : 'label'"
                            [id]="'tire-position-'+i" [fontSize]="14" [disabled]="!dot.dotNumber"
                            [listItemFontSize]="14" [options]="tirePositions" [value]="dot.tirePosition"
                            (appSelect)="onCardTypeSelect($event, dot)" [isDropdownIconVisible]="true">
                        </app-dropdown>
                    </div>
                </div>
                <!-- </div> -->
            </ng-container>
        </ng-container>
    </div>

    <!-- Star Footer -->
    <div class="ui-g-12 flex-between-end tire-dot-number-footer p-0 ">
        <div class="tire-dot-number-footer d-flex justify-content-end width-100p">
            <button *ngIf="!data.isAllServiceItems || data.isDotNumberReqOnInv" id="part-cancel-btn"
                class="btn btn-white btn-border pointer btn-submit ml-2" (click)="closeDialog('close')">{{currentLang === 'fr' ? 'Annuler' : 'Cancel'}}</button>

            <button *ngIf="data.isAllServiceItems && !data.isDotNumberReqOnInv" id="part-cancel-btn"
                class="btn btn-white btn-border pointer btn-submit ml-2" (click)="closeDialog('skip')">{{currentLang === 'fr' ? 'Sauter' : 'Skip'}}</button>

            <button id="part-save-btn" class="btn btn-primary btn-submit pointer ml-2" (click)="saveTireDotNumbers()">
                <span class="font-bold">{{currentLang === 'fr' ? 'Sauvegarder' : 'Save'}}</span>
            </button>
        </div>
    </div>
</div>